<template>
  <div class="clearfix">
    <div class="reservation-table-row" :style="rowStyle">
      <slot name="body" :ticks="ticks">
        <reservation-table-cell
          @click.native="clickCell(tick)"
          v-for="tick in ticks"
          :key="tick.toISOString()"
          v-bind="cellAttrs"
          :height="height"
          :tick=tick>
        </reservation-table-cell>
      </slot>
      <div
        v-for="reservation in reservations"
        :key="reservation.pk"
        :style="boxStyle(reservation)"
        class="reservation-box">
        <slot :name="reservation.pk" :reservation="reservation">
        </slot>
      </div>
      <time-pointer v-bind="timePointerAttrs" />
    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import { extendMoment } from 'moment-range'

import ReservationTableCell from './Cell'
import TimePointer from './TimePointer'

const moment = extendMoment(Moment)

export default {
  name: 'ReservationTableRow',
  props: {
    ticks: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    reservations: {
      type: Array,
      default: () => { return [] },
    },
    startAt: {
      type: Object,
      required: true,
    },
    endAt: {
      type: Object,
      required: true,
    },
    reservationBoxMarginTop: {
      type: Number,
      required: true,
    },
    reservationBoxHeight: {
      type: Number,
      required: true,
    },
    trackHeight: {
      type: Number,
      required: true,
    },
    pxPerMinute: {
      type: Number,
      required: true,
    },
    tickDuration: {
      type: Number,
      required: true,
    },
    borderColorDefault: {
      type: String,
      required: true,
    },
    backgroundColorFocused: {
      type: String,
      required: true,
    },
    tickBorderWidth: {
      type: Number,
      required: true,
    },
    borderTopWidth: {
      type: Number,
      required: true,
    },
    borderBottomWidth: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    timePointerAttrs () {
      return {
        pxPerMinute: this.pxPerMinute,
        startAt: this.startAt,
        endAt: this.endAt,
        height: this.height,
      }
    },
    rowStyle () {
      return {
        width: this.ticks.length * (this.pxPerCell + 3) + 'px',
      }
    },
    pxPerCell () {
      return this.pxPerMinute * this.tickDuration
    },
    cellAttrs () {
      return {
        height: this.height,
        pxPerCell: this.pxPerCell,
        borderColorDefault: this.borderColorDefault,
        backgroundColorFocused: this.backgroundColorFocused,
        tickBorderWidth: this.tickBorderWidth,
        borderTopWidth: this.borderTopWidth,
        borderBottomWidth: this.borderBottomWidth,
      }
    },
  },
  methods: {
    clickCell (tick) {
      this.$emit('clickCell', tick.clone())
    },
    boxStyle (reservation) {
      let ret = {
        left: this.boxLeft(reservation) + 'px',
        width: this.boxWidth(reservation) + 'px',
        top: this.boxTop(reservation) + 'px',
        height: this.reservationBoxHeight + 'px',
        'background-color': this.boxBackgroundColor(reservation),
      }
      return ret
    },
    boxLeft (reservation) {
      let range = moment.range(this.startAt, reservation.startAt)
      return this.pxPerMinute * range.diff('minutes')
    },
    boxWidth (reservation) {
      let range = moment.range(reservation.startAt, reservation.endAt)
      return range.diff('minutes') * this.pxPerMinute
    },
    boxTop (reservation) {
      let track = reservation.track
      return track * (this.trackHeight) + this.reservationBoxMarginTop
    },
    boxBackgroundColor (reservation) {
      return '#fff'
    },
  },
  components: {
    ReservationTableCell,
    TimePointer,
  },
}
</script>

<style scoped>
.reservation-table-row {
  position: relative;
  box-sizing: border-box;
}

.clearfix::after {
  display: block;
  content: "";
  clear: both;
}

.reservation-box {
  position: absolute;
  box-shadow: 2px 2px 2px -1px #aaa;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Table/Row.vue